import * as React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/auth/AuthProvider';

/**
 * AuthGuard — wraps protected routes (e.g. `/dashboard`).
 *
 * MSAL-aware variant (W1-F6-S2): when no Entra account is present, redirects
 * unauthenticated users to `/login`. The `from` location is preserved so a
 * future "return to where you were" flow can pick it up.
 */
export interface AuthGuardProps {
  children: React.ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps): JSX.Element {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return <>{children}</>;
}
